var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.table,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }